<ng-content select="progress"></ng-content>
<ng-content select="prizm-progress-circle"></ng-content>
<span class="z-label prizm-font-input-text-helper">
  <ng-content></ng-content>
</span>
